import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Container,
  Breadcrumbs,
  Link,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import { 
  Work as WorkIcon,
  CheckCircle as CheckIcon,
  Email as EmailIcon,
} from '@mui/icons-material';

export const PSPReports = () => {
  const handleContactUs = () => {
    window.open('mailto:sales@driververified.com', '_blank');
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs sx={{ mb: 3 }}>
        <Link 
          color="inherit" 
          href="/services" 
          sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
        >
          Services
        </Link>
        <Typography color="text.primary">Pre-Employment Screening Program (PSP) Reports</Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
          Pre-Employment Screening Program (PSP) Reports
        </Typography>
      </Box>

      {/* Main Content */}
      <Card sx={{ mb: 4, boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)' }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
            Do I need a PSP Report?
          </Typography>
          
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#1976d2', mb: 2 }}>
              If you hire drivers to drive cross-border into the United States, you must have their PSP report included in their driver file
            </Typography>
          </Box>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            What is a Pre-Employment Screening Program (PSP) Report?
          </Typography>
          
          <List sx={{ mb: 3 }}>
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemIcon sx={{ mt: 0.5 }}>
                <CheckIcon color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="PSP Reports provides carriers access to American commercial driver safety records from the Federal Motor Carrier Safety Administration's (FMCSA) Motor Carrier Management Information System (MCMIS)."
              />
            </ListItem>
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemIcon sx={{ mt: 0.5 }}>
                <CheckIcon color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="The PSP report for commercial drivers includes their 5 year crash history, and 3 year inspection history."
              />
            </ListItem>
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemIcon sx={{ mt: 0.5 }}>
                <CheckIcon color="primary" />
              </ListItemIcon>
              <ListItemText 
                primary="The records indicate the motor carrier under which the driver was employed at the time of the crash or inspection, in addition to the location and date. Further information provided includes injuries, fatalities, towaways, and whether a vehicle was placed out of service."
              />
            </ListItem>
          </List>

          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            As a cross-border carrier, it's legally required for you to have each driver's PSP report in their driver file. 
            However, there are additional benefits to using PSP reports to screen driver candidates:
          </Typography>

          <List sx={{ mb: 4 }}>
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemIcon sx={{ mt: 0.5 }}>
                <CheckIcon color="success" />
              </ListItemIcon>
              <ListItemText 
                primary="Lower their crash rate by 8%"
                secondary="[data compiled by the FMCSA]"
              />
            </ListItem>
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemIcon sx={{ mt: 0.5 }}>
                <CheckIcon color="success" />
              </ListItemIcon>
              <ListItemText 
                primary="Lower their driver out-of-service rate by 17%, on average"
                secondary="[data compiled by the FMCSA]"
              />
            </ListItem>
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemIcon sx={{ mt: 0.5 }}>
                <CheckIcon color="success" />
              </ListItemIcon>
              <ListItemText 
                primary="Increased protection against liability"
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>

      {/* Contact Section */}
      <Card sx={{ boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)' }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
            How do I order a PSP Report? Contact us to place your order today!
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={handleContactUs}
            startIcon={<EmailIcon />}
            sx={{
              mt: 2,
              backgroundColor: '#4ecdc4',
              '&:hover': { backgroundColor: '#45b7d1' },
              px: 4,
              py: 1.5,
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            sales@driververified.com
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
}; 